<div class="tags">
  <div [ngClass]="classes(category)" *ngFor="let category of categories">
    <span *ngIf="elementType == 'other'">
      {{ 'PROJECTS.CATEGORIES.' + category.slug | translate }}
    </span>

    <a *ngIf="elementType != 'other'" [routerLink]="category.id | tagRouterLink:elementType"
       [queryParams]="category.id | tagQueryParams" (click)="$event.stopPropagation()">
      {{ 'PROJECTS.CATEGORIES.' + category.slug | translate }}
    </a>
  </div>
</div>
